import React from "react";
import termsNConditions from "../assets/Omnisource_PRIVACY_POLICY.pdf";

const Privacy = () => {
  return (
    <embed
      src={termsNConditions}
      style={{
        height: "100vh",
        border: "none",
        width: "100%",
      }}
    />
  );
};

export default Privacy;
